var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 4,
  x: 3,
  y: 3,
  rx: 1.25
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 4,
  x: 3,
  y: 10,
  rx: 1.25
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 4,
  x: 3,
  y: 17,
  rx: 1.25
})));
export default SvgMenu;